import { ExtrudeSolidT, ModelUtils } from "pytha";

/**
 * 结构板
 */

export class SFloorT extends ExtrudeSolidT {
    type = 'SFloorT';
    materialUuid: string;

    setMaterialUuid(materialUuid: string) {
        this.materialUuid = materialUuid;
    }

    clone() {
        const entity = new SFloorT().copy(this);
        entity.uuid = ModelUtils.generateUUID();
        return entity;
    }

    toJson() {
        let parentJson = super.toJson();
        let data = {
            ...parentJson,
            type: this.type,
            materialUuid: this.materialUuid
        }

        return data;
    }

    fromJson(json) {
        super.fromJson(json);
        return this;
    }



}